import {
  Image, Spacing, SpacingName, Typography,
} from '@doveit/lego';
import React from 'react';
import * as styles from './InfoItem.style';

export interface InfoItemProps {
  picture: string,
  title: string,
  description: string,
}

const InfoItem: React.FC<InfoItemProps> = ({
  picture,
  title,
  description,
}) => (
  <div css={styles.base}>
    <div css={styles.picture}>
      <div css={styles.pictureWrapper}>
        <Image
          src={picture}
          alt={title}
          loading="lazy"
        />
      </div>
    </div>
    <div css={styles.info}>
      <Typography.H3 tagName="div">
        {title}
      </Typography.H3>
      <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
        {description}
      </Spacing>
    </div>
  </div>
);

export default InfoItem;
